import { ReactElement } from 'react';
import { HiOutlineNewspaper } from 'react-icons/hi2';
import { BsFiletypeCsv, BsFiletypeXlsx } from 'react-icons/bs';
import Tooltip from '../Tooltip';

type Props = {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
};

export const FileDownloadCSV = ({ onClick, disabled, className }: Props): ReactElement => (
  <Tooltip title="Download CSV file" placement="top">
    <button
      onClick={onClick}
      disabled={disabled}
      className={`cr-rounded-full cr-bg-gray-100 cr-p-2 cr-text-[#03365D] cr-transition-colors cr-duration-200 hover:cr-bg-cirrusBlue-50 active:cr-bg-cirrusBlue-100 disabled:cr-cursor-not-allowed disabled:cr-opacity-50 ${className || ''}`}
    >
      <BsFiletypeCsv className="cr-size-6" />
    </button>
  </Tooltip>
);

export const FileDownloadXLS = ({ onClick, disabled, className }: Props): ReactElement => (
  <Tooltip title="Download XLS Tables" placement="top">
    <button
      onClick={onClick}
      disabled={disabled}
      className={`cr-rounded-full cr-bg-gray-100 cr-p-2 cr-text-[#03365D] cr-transition-colors cr-duration-200 hover:cr-bg-cirrusBlue-50 active:cr-bg-cirrusBlue-100 disabled:cr-cursor-not-allowed disabled:cr-opacity-50 ${className || ''}`}
    >
      <BsFiletypeXlsx className="cr-size-6" />
    </button>
  </Tooltip>
);

export const FileDownloadXLSReport = ({ onClick, disabled, className }: Props): ReactElement => (
  <Tooltip title="Download Formatted XLS report" placement="top">
    <button
      onClick={onClick}
      disabled={disabled}
      className={`cr-rounded-full cr-bg-gray-100 cr-p-2 cr-text-[#03365D] cr-transition-colors cr-duration-200 hover:cr-bg-cirrusBlue-50 active:cr-bg-cirrusBlue-100 disabled:cr-cursor-not-allowed disabled:cr-opacity-50 ${className || ''}`}
    >
      <HiOutlineNewspaper className="cr-size-6" />
    </button>
  </Tooltip>
);
